<template>
  <content-wrapper>
    <content-header>
      Dashboard
    </content-header>
    <Content>
      <!-- Small boxes (Stat box) -->
      <div class="row">
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-info">
            <div class="inner">
              <h3>{{ stats.truck }}</h3>
              <p>Trucks Registered</p>
            </div>
            <div class="icon">
              <i class="fa fa-truck-moving"></i>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-warning">
            <div class="inner">
              <h3>{{ stats.permit_open }}</h3>
              <p>Permit Open</p>
            </div>
            <div class="icon">
              <i class="ion ion-person-add"></i>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-danger">
            <div class="inner">
              <h3>{{  stats.permit_used }}</h3>
              <p>Permits Used</p>
            </div>
            <div class="icon">
              <i class="ion ion-document-text"></i>
            </div>
<!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
        <!-- ./col -->
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-success">
            <div class="inner">
              <h3>{{  stats.completed }}<sup style="font-size: 20px">%</sup></h3>
              <p>Permit Completed Rate</p>
            </div>
            <div class="icon">
              <i class="ion ion-stats-bars"></i>
            </div>
            <!--            <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a>-->
          </div>
        </div>
      </div>
      <!-- /.row -->
      <!-- Main row -->
      <div class="row" v-if="isSuperAdmin">
        <!-- Left col -->
        <section class="col">
          <!-- Custom tabs (Charts with tabs)-->
          <b-card no-body header="Quick Actions" header-bg-variant="secondary">
            <b-tabs pills card>
              <b-tab title="Add Member" active>
                <b-card-text>
                  <registration-form @registered="showPassword"></registration-form>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
          <!-- /.card -->
        </section>
        <!-- /.Left col -->
      </div>
      <!-- /.row (main row) -->
    </Content>
    <!-- Credential Modal -->
    <b-modal v-if="isSuperAdmin" centered header-bg-variant="success" id="credential" size="sm" title="Keep this password"
             ok-only
             no-close-on-esc
             hide-header-close
             no-close-on-backdrop>
      <h4>Please save this Password</h4>
      <h1 class="text-center">{{ password }}</h1>
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="password=null;cancel();">
          OK!
        </b-button>
      </template>
    </b-modal>
  </content-wrapper>
</template>

<script>
import {userInfoMixin} from "@/mixins/userInfoMixin";
import {getDashStats} from "@/services/members";
import {BTab, BTabs} from "bootstrap-vue";
import RegistrationForm from "@/views/Members/RegistrationForm";
export default {
  name: "Dashboard",
  components: {
    BTab, BTabs,
    RegistrationForm,
  },
  mixins: [
      userInfoMixin,
  ],
  data: () => ({
    stats: {
      truck: 0,
      permit_open: 0,
      permit_used: 0,
      completed: 0,
    },
    isSubmitting: false,
    password: '',
  }),
  methods: {
    async getStats() {
      let params = {};
      if (!this.isSuperAdmin) {
        params['member'] = this.member.id
      }
      const { data: { data: { dashboard }}} = await getDashStats(params);
      this.stats = dashboard;
      this.stats.completed = dashboard.permit_used / (dashboard.permit_open + dashboard.permit_used);
      this.stats.completed = Math.round((this.stats.completed + Number.EPSILON) * 100 );
    },
    showPassword({user}){
      this.password = user.paswd;
      this.$bvModal.show('credential')
    },
    async addNewUser(){},
  },
  mounted() {
    this.getStats();
  }
}
</script>

<style scoped>

</style>
